import Vue from 'vue';
// miment 是 moment 的轻量级替代版，常用功能都有
import miment from 'miment';
// 注入 Vue 实例
Vue.prototype.$miment = miment;